import { Cubby } from "../Cubby";

export const sendFundsDirectiveAndWarning = (cubby: Cubby) => {
  if (!cubby.sixConfirmationEstimateOrNull) {
    return {
      allow: true,
      warning: null,
      error: null,
    };
  }
  if (cubby.sixConfirmationEstimateOrNull.fee > cubby.safeChainBalance / 2) {
    return {
      allow: false,
      warning: null,
      error:
        "The projected fee to send a payment is " +
        cubby.sixConfirmationEstimateOrNull.fee.toLocaleString() +
        " satoshis. This is more than half your balance. Please try again when fees are lower.",
    };
  }
  console.log("fell through in sendFundsDirectiveAndWarning");
  return {
    allow: true,
    warning: null,
    error: null,
  };
};
